import { render, staticRenderFns } from "./RoomOutbuilding.vue?vue&type=template&id=4fec1808&scoped=true"
import script from "./RoomOutbuilding.vue?vue&type=script&lang=ts"
export * from "./RoomOutbuilding.vue?vue&type=script&lang=ts"
import style0 from "./RoomOutbuilding.vue?vue&type=style&index=0&id=4fec1808&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fec1808",
  null
  
)

export default component.exports